import type { NotificacaoSistemaResponse } from '@/models/response/admin/NotificacaoSistemaResponse'
import api from '@/plugins/axios'
import type { Page, Pageable } from '@/types/api'

class NotificacaoService {
  private baseUrl = '/notificacao'

  async findAll(pageable: Pageable): Promise<Page<NotificacaoSistemaResponse>> {
    const { data } = await api.get<Page<NotificacaoSistemaResponse>>(this.baseUrl, { params: pageable })
    return data
  }

  async contarNaoLidas(): Promise<number> {
    const { data } = await api.get<{ quantidade: number }>(`${this.baseUrl}/nao-lidas`)
    return data.quantidade
  }

  async marcarComoLida(id: number): Promise<void> {
    await api.put(`${this.baseUrl}/${id}/lida`)
  }

  async marcarTodasComoLidas(): Promise<void> {
    await api.put(`${this.baseUrl}/marcar-todas-lidas`)
  }
}

export default new NotificacaoService()
